import { useMutation, useQuery } from 'react-query';
import { groupResponse } from 'src/models/CRM';
import {
  createGroupRequest,
  updateGroupRequest,
  vrcGroupMessage,
  vrcGroupResponse
} from 'src/models/vrc';
import {
  AddVrcGroupUsers,
  CreateVrcGroup,
  DeleteVrcGroupUsers,
  DisableGroupChat,
  UpdateVrcGroup,
  fetchVrcGroupById,
  fetchVrcGroupMessagesById,
  fetchVrcGroups
} from 'src/services/vrc';

export function useCreateGroup() {
  return useMutation((data: createGroupRequest) => CreateVrcGroup(data));
}

export function useUpdateGroup() {
  return useMutation((data: updateGroupRequest) => UpdateVrcGroup(data));
}

export function useDeleteGroupUsers() {
  return useMutation((data: { users: number[]; id: number }) =>
    DeleteVrcGroupUsers(data)
  );
}

export function useAddGroupUsers() {
  return useMutation((data: { users: number[]; id: number }) =>
    AddVrcGroupUsers(data)
  );
}

export function useDiableGroupChat() {
  return useMutation((data: { is_read_only: boolean; id: number }) =>
    DisableGroupChat(data)
  );
}

export function useGetGroups(onSuccess: (data: vrcGroupResponse[]) => void) {
  return useQuery({
    queryKey: ['groups'],
    queryFn: fetchVrcGroups,
    onSuccess: (data) => {
      onSuccess(data!);
    },
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchInterval: false,
  });
}

export function useGetGroupById(id: number) {
  return useQuery(['group', id], () =>
    id != 0 ? fetchVrcGroupById(id) : null
  );
}

export function useGetGroupMessagesById(
  id: number,
  onSuccess: (data: vrcGroupMessage[]) => void
) {
  return useQuery(
    ['group-messages', id],
    () => (id ? fetchVrcGroupMessagesById(id) : null),
    {
      onSuccess: (data) => {
        onSuccess(data!);
      },
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchOnMount: false
    }
  );
}
